const backgroundText = document.querySelector('.backgroundText')

window.addEventListener('wheel', ()=> {
    const scroll = window.pageYOffset / 15;
    backgroundText.style.transform = `translate3d(${-scroll}px, 0, 0)`;
  });